<section class="page-banner">
    <h1 class="page-banner__title">{{heading()}}</h1>
</section>
